<mat-form-field appearance="standard" [formGroup]="group">
    <mat-label>{{config.placeholder}}</mat-label>
    <mat-select placeholder="{{config.name}}" [formControlName]="config.name">
        <mat-option *ngFor="let option of config.options" [value]="option.value">
            {{ option.value }}
        </mat-option>
    </mat-select>

</mat-form-field>
